export * from "./server_env.js";

export const getEnv = () => {
  const isLocal =
    window.location.hostname.includes("localhost") ||
    window.location.hostname.endsWith(".trycloudflare.com");
  if (isLocal) return "local";
  const isDev = window.location.hostname.includes(".dev.");
  if (isDev) return "development";
  const isStaging = window.location.hostname.includes(".staging.");
  if (isStaging) return "staging";
  return "production";
};
